import React, { useEffect, useState } from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import { PREVIEW_PAGE_TYPES } from "../../../constants";

const InterstitialAd = ({ lang, pageType }) => {
  const [slotId, setSlotId] = useState("interstial-ad");
  const [adType, setAdType] = useState();

  const getAdType = () => {
    if (lang === "en") {
      if (pageType === "home-page") {
        return "EnPalo_HP_Int_660x440";
      } else {
        return "EnPalo_Inner_Int_660x440";
      }
    } else {
      if (pageType === "home-page") {
        return "home_Int_660x440";
      } else {
        return "News_Int_660x440";
      }
    }
  };

  useEffect(() => {
    setSlotId((prev) => `${prev}-` + 1);
    setAdType(getAdType());
  }, [pageType]);

  return (
    <DfpContainer pages={PREVIEW_PAGE_TYPES}>
      <DfpComponent type={adType || getAdType()} slotId={slotId} />
    </DfpContainer>
  );
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "en"),
  pageType: get(state, ["qt", "pageType"], ""),
});

InterstitialAd.propTypes = {
  lang: string,
  pageType: string,
};

export default connect(mapStateToProps)(InterstitialAd);
